"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const websocket_1 = require("../const/websocket");
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
// var ws = null
// /* tslint:disable */
// if (typeof WebSocket !== 'undefined') {
//   ws = WebSocket
// } else if (typeof MozWebSocket !== 'undefined') {
//   ws = MozWebSocket
// } else if (typeof global !== 'undefined') {
//   ws = global.WebSocket || global.MozWebSocket
// } else if (typeof window !== 'undefined') {
//   ws = window.WebSocket || window.MozWebSocket
// } else if (typeof self !== 'undefined') {
//   ws = self.WebSocket || self.MozWebSocket
// }
// /* tslint:enable */
const defaultConfig = {
    url: "",
    requireValidSsl: true,
    useTls: true,
};
class NodeWebSocket {
    constructor(config) {
        this._handleOpen = () => {
            this.events.emit("open");
        };
        this._handleClose = () => {
            this.events.emit("close");
        };
        this._handleError = () => {
            this.events.emit("error");
        };
        this._handleMessage = (data) => {
            this.events.emit("message", data);
        };
        this.config = Object.assign(defaultConfig, config);
        this.client = null;
        this.events = new events_1.EventEmitter();
    }
    open() {
        // tslint:disable-next-line
        if (typeof WebSocket === "undefined") {
            this.client = new isomorphic_ws_1.default(this.config.url, {
                origin: "https://websocket.org",
            });
            if (this.client !== null) {
                this.client.onopen = this._handleOpen;
                this.client.onclose = this._handleClose;
                this.client.onerror = this._handleError;
                this.client.onmessage = this._handleMessage;
            }
        }
        else {
            this.client = new WebSocket(this.config.url);
            this.client.onopen = this._handleOpen;
            this.client.onclose = this._handleClose;
            this.client.onerror = this._handleError;
            this.client.onmessage = this._handleMessage;
        }
    }
    close() {
        try {
            if (this.client !== null) {
                this.client.close();
            }
        }
        catch (_a) { }
        this.client = null;
    }
    send(message) {
        if (this.client !== null) {
            this.client.send(message);
        }
        else {
            console.error("Websocket not available");
        }
    }
    on(event, handler) {
        this.events.on(event, handler);
    }
    state() {
        if (this.client === null) {
            return websocket_1.WEBSOCKET_READYSTATE.CLOSED;
        }
        return this.client.readyState;
    }
}
exports.NodeWebSocket = NodeWebSocket;
exports.default = (config) => new NodeWebSocket(config);
